import React from "react";
import { LinearProgress } from "@mui/material";

const DSLinearProgress = (
  props: React.ComponentProps<typeof LinearProgress>,
) => {
  return <LinearProgress {...props} />;
};

export default DSLinearProgress;
